import { BASE_API_URL_CAP_DIEN } from "@utils/constants";

export const APICauHinhChung = {
  LIST_CAU_HINH_CHUNG: `${BASE_API_URL_CAP_DIEN}/cau-hinh/list`,
  CREATE_CAU_HINH_CHUNG: `${BASE_API_URL_CAP_DIEN}/cau-hinh/create`,
  UPDATE_CAU_HINH_CHUNG: `${BASE_API_URL_CAP_DIEN}/cau-hinh/update`,
  REMOVE_CAU_HINH_CHUNG: `${BASE_API_URL_CAP_DIEN}/cau-hinh/delete`,
};
